import api from "../../../api/api";
import API_URL from "../../../api/url";
import axios from 'axios';

const WebBannerRequest = {
  // categoryList: (page, limit) => api.get(`${API_URL.BASEURL}${API_URL.getCategory}?page=${page}&limit=${limit}`),
  getbannerList: (values) => api.get(`${API_URL.BASEURL}${API_URL.webGetBanner}`, {
    params: {
      search: values?.search
    }
  }),
  postDeleteBanner: (id) => api.delete(`${API_URL.BASEURL}${API_URL.webBannerDelete}?id=${id}`),
  postUpdateBanner: (values) => api.post(`${API_URL.BASEURL}${API_URL.webUpdateBanner}`, values),
  getBannerDetail: (id) => api.get(`${API_URL.BASEURL}${API_URL.webBannerDetails}?id=${id}`),
  createBanner: (values) => api.post(`${API_URL.BASEURL}${API_URL.webCreateBanner}`, values),
  getPathIddetails :  (selectedPathType) => api.get(`${API_URL.BASEURL}${API_URL.BannerPathidDetails}?pathType=${selectedPathType}`),

  uploadImage: (formData) => {
    const token = localStorage.getItem("accesstoken");


    return api.post(
      `${API_URL.BASEURL}${API_URL.uploadImg}?moduleName=photos`,
      formData,
      {
        headers: {
          token: token ? `${token}` : "",
        },
      }
    );
  }


};



export default WebBannerRequest